module.exports = " <main class=wrapper _v-05b904ad=\"\"> <navigation-componenet _v-05b904ad=\"\"></navigation-componenet> <header-componenet :show-header=show_header v-show=\"['main'].indexOf($route.name) > -1\" _v-05b904ad=\"\"> </header-componenet> <router-view class=view keep-alive=\"\" transition=\"\" transition-mode=out-in _v-05b904ad=\"\"> </router-view> </main> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-05b904ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 123
 ** module chunks = 2
 **/